import axios from "axios";

const productInit = ()=> {
    const addProductToShoppingCartHandle = () => {


        const addProductToShoppingCartElms = document.querySelectorAll('[data-add-to-shopping-cart]');
        const headerShoppingCartElm = document.querySelector('.header__shopping_cart');

        addProductToShoppingCartElms.forEach((item) => {
            item.addEventListener('click', function (e) {
                e.preventDefault(); e.stopPropagation();

                if (!item.classList.contains('active')) {

                    const itemId = parseInt(item.dataset.id);
                    const itemModel = item.dataset.module;
                    let value = 0;

                    if (item.closest('.product__item_price_type')) {
                        value = item.closest('.product__item_price_type').querySelector('.square').value;
                        // console.log('value1', value)
                        if (value) {
                            value = value.replace(',', '.');
                        } else {
                            value = 0;
                        }

                    }

                    axios
                        .post('/add-to-cart', {
                            id: itemId,
                            module: itemModel,
                            qty: value
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                    .then((response) => {
                        if (response) {
                            headerShoppingCartElm.classList.add('has-items');
                            item.classList.add('animated');

                            const squareElm = document.querySelector('.square');
                            if (squareElm) {
                                squareElm.value = '';
                            }

                            setTimeout(function () {
                                item.classList.remove('animated');
                                item.classList.add('active');
                            }, 1000);
                        }
                    })
                }
            });
        });

    }

    return {
        addProductToShoppingCartHandle,
    }
}

export default productInit;
